import { create } from "zustand";
import { IUserInfo } from "./types/IUserInfo";
import { IOption } from "./types/IOption";
import { IOrderSource } from "./types/IOrderSource";
import { EnumTypes } from "./utils/constants";
import { IExpiryConfig } from "./types/IExpiryConfig";

interface State {
  currentUserInfo: IUserInfo | null;
  setCurrentUserInfo: (currentUserInfo: IUserInfo | null) => void;
  enums: {
    [EnumTypes.ITEM_SIZE]?: IOption[];
    [EnumTypes.PAYMENT_MODE]?: IOption[];
    [EnumTypes.DISCOUNT_UNIT]?: IOption[];
    [EnumTypes.ITEM_CATEGORIES]?: IOption[];
    [EnumTypes.ORDER_SOURCE]?: IOrderSource[];
    [EnumTypes.EXPENSE_SOURCE]?: IOption[];
    [EnumTypes.EXPIRY_CONFIG]?: IExpiryConfig[];
  };
  setEnums: (enums: { [key: string]: IOption[] }) => void;
}

const useStore = create<State>((set) => ({
  currentUserInfo: null,
  setCurrentUserInfo: (currentUserInfo: IUserInfo | null) =>
    set({ currentUserInfo }),

  enums: {},
  setEnums: (enums: { [key: string]: IOption[] }) => set({ enums }),
}));

export default useStore;
